<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :persistent="loading"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-on="on" v-bind="attrs" :disabled="disabled">
        <v-icon>
          mdi-account-minus
        </v-icon>
      </v-btn>
    </template>

    <v-toolbar dense>
      <v-toolbar-title>
        <span>
          {{ $t("freespins.removingAdhesion") }}
        </span>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="closeDialog" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text class="pa-4">
        <v-alert
          border="left"
          colored-border
          type="info"
          color="#B50000"
          elevation="2"
        >
          <span style="font-size: 12px; font-weight: 400;">
            {{ $t("freespins.removeAlert") }}
          </span>
        </v-alert>

        <div
          v-html="
            $t('freespins.remove', {
              player: adhesion.user_name,
              title: campaignTitle,
            })
          "
        ></div>
      </v-card-text>

      <v-card-actions class="pr-4 pb-4">
        <v-spacer />
        <v-btn
          class="white black--text"
          @click="closeDialog"
          outlined
          small
          :disabled="loading"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          @click="confirm"
          color="#B50000"
          small
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    adhesion: {
      type: Object,
    },
    campaignTitle: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    campaignId: {
      type: String,
    }
  },

  data: () => ({
    dialog: false,
    loading: false,
  }),

  methods: {
    confirm() {
      if (this.disabled) {
        return;
      }

      this.loading = true;

      const body = {
        user_id: this.adhesion.user_id,
        campaign_freespins_id: this.campaignId,
      };

      this.$axios
        .post(
          `${this.$prefix()}/cassino/gamesAgregation/removeFreespinsFromUser`,
          this.$formdata(body)
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("removeAdhesion", { userId: this.adhesion.user_id });
        })
        .finally(() => {
          this.loading = false;
          this.closeDialog();
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
